import Vuex from 'vuex'

import currentUserInfo from './modules/currentUserInfo'
import jewelHistories from './modules/jewelHistories'
import requestForm from './modules/requestForm'
import serverConstants from './modules/serverConstants'
import session from './modules/session'

async function sleep (t) {
  return new Promise((resolve) => setTimeout(() => { resolve() }, t))
}

export default () => {
  return new Vuex.Store({
    modules: {
      currentUserInfo,
      jewelHistories,
      requestForm,
      serverConstants,
      session
    },
    state: {
      alertMessage: null,
      closeTimeout: null
    },
    mutations: {
      setAlertMessage (state, { message }) {
        state.alertMessage = message
      },
      setCloseTimeout (state, { timeout }) {
        state.timeout = timeout
      }
    },
    actions: {
      async displayAlert ({ commit, dispatch, state }, { message, duration = 10000 }) {
        if (state.closeTimeout) {
          dispatch('closeAlert')
          await sleep(300)
        }
        commit('setAlertMessage', { message })
        commit('setCloseTimeout', setTimeout(() => { dispatch('closeAlert') }, duration))
      },
      closeAlert ({ commit, state }) {
        if (state.closeTimeout) {
          clearTimeout(state.closeTimeout)
          commit('setCloseTimeout', { timeout: null })
        }
        commit('setAlertMessage', { message: null })
      }
    }
  })
}
